import React, { useEffect, useState } from 'react';
import EcoSpace from 'eco-design/base/eco-space';
import EcoSpaceSmall from 'eco-design/base/eco-space-small';
import EcoSectionCommon from 'eco-design/elements/eco-section-common';
import EFPicture from '@elem/compCommon/EFPicture';
import EcoButton from 'eco-design/base/eco-button';
import { getIsPadWidth } from '@elem/utils/devices';
import Close from '@elem/SVGIcon/125wRigidSolarPanel/Close';
import { useProductStore } from '@elem/compPage/outdoor-campaign/ProductProvider';
import { IPageStatus } from '@elem/compPage/outdoor-campaign/config/IPageStatus';

import styles from './index.module.scss';
import { useLang } from '@/i18n';

export default function Comp() {
    const { t } = useLang('theProduct.SectionA1');
    const isMobile = getIsPadWidth();
    const [activeContent, setActiveContent] = useState(0);
    const { pageStatus } = useProductStore();

    const productList = {
        desc: t('desc'),
        pc: 'https://websiteoss.ecoflow.com/upload/image/1741763683713/charger_section3_1.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1741763683713/charger_section3_1.jpg',
        link: 'https://jp.ecoflow.com/products/delta-2-max-portable-power-station',
        icons: [
            { title: t('icon_title_1'), icon: 'https://websiteoss.ecoflow.com/upload/image/1745068296287/icon_1.svg' },
            { title: t('icon_title_2'), icon: 'https://websiteoss.ecoflow.com/upload/image/1745068296831/icon_2.svg' },
            { title: t('icon_title_3'), icon: 'https://websiteoss.ecoflow.com/upload/image/1745307739658/icon_5.svg' },
        ],
    };

    const tipsData = [
        {
            title: t('tip_1_title'),
            content: t('tip_1_desc'),
            link: 'https://jp.ecoflow.com/products/delta-2-max-portable-power-station',
            icon: 'https://websiteoss.ecoflow.com/upload/image/1745047363956/D2M.png',
            lChildren: t('button_text'),
            lDataLayer: {
                event: 'uaEvent',
                event_name: 'buy',
                product_name: t('tip_1_title'),
                position: 'Product Detail',
            },
        },
        {
            title: t('tip_2_title'),
            content: t('tip_2_desc'),
            link: 'https://www.ecoflow.com/jp/wave-3-portable-air-conditioner',
            icon: 'https://websiteoss.ecoflow.com/upload/image/1745047364138/WAVE3.png',
            lDisabled: pageStatus === IPageStatus.statusA,
            lChildren: pageStatus === IPageStatus.statusA ? t('button_text2') : t('button_text'),

            lDataLayer: {
                event: 'uaEvent',
                event_name: 'select_product',
                list_name: 'Product Preview',
                product_name: t('tip_2_title'),
                button_name: t('button_text'),
            },
        },
        {
            title: t('tip_3_title'),
            content: t('tip_3_desc'),
            link: 'https://jp.ecoflow.com/products/ecoflow-800w-alternator-charger',
            icon: 'https://websiteoss.ecoflow.com/upload/image/1745047363622/alternator_charger_800W.png',

            lChildren: t('button_text'),

            lDataLayer: {
                event: 'uaEvent',
                event_name: 'buy',
                product_name: t('tip_3_title'),
                position: 'Product Detail',
            },
        },
    ];

    const handleBtnClick = (index: number) => {
        if (!!activeContent && activeContent === index + 1) {
            setActiveContent(0);
            return;
        }
        setActiveContent(index + 1);
    };

    return (
        <section className={`${styles.comp} temp-section-2`} id="section-2">
            <EcoSpace className="section-2-top-space" />
            <EcoSectionCommon title={t('title')} />
            <EcoSpaceSmall />
            <div className="temp-section-2-container">
                <div className={`temp-section-2-box`}>
                    <div className="temp-section-content-left">
                        <div className="content-left-img">
                            <EFPicture
                                src="https://websiteoss.ecoflow.com/upload/image/1745204170425/section_a_1.jpg"
                                srcPad="https://websiteoss.ecoflow.com/upload/image/1745045971868/section_a_1_h5.jpg"
                                srcMobile="https://websiteoss.ecoflow.com/upload/image/1745045971868/section_a_1_h5.jpg"
                            />
                        </div>

                        <div className="imgs-box-bottom">
                            {tipsData?.map((item: any, index: number) => (
                                <div key={index} className={`actions-box actions-box-${index + 1} ${activeContent === index + 1 ? 'actions-box-active' : ''}`}>
                                    {activeContent === index + 1 && (
                                        <div className={`tip-hidden-content`}>
                                            <div className="tip-hidden-img">
                                                <EFPicture src={item.icon} />
                                            </div>
                                            {!!item?.title && <p className="tip-hidden-title">{item?.title}</p>}
                                            <p className="tip-hidden-content-item">{item?.content}</p>
                                            <EcoButton
                                                lDisabled={item?.lDisabled}
                                                lChildren={item?.lChildren}
                                                lRadius="ellipse"
                                                lHref={item.link}
                                                lDataLayer={item.lDataLayer}
                                            />
                                        </div>
                                    )}
                                    <div className="tip-visible-content">
                                        <div
                                            className={`close-icon ${activeContent === index + 1 ? 'close-icon-active' : ''}`}
                                            onClick={() => handleBtnClick(index)}
                                        >
                                            <Close />
                                        </div>
                                        {/* {!!item?.title && <p className="tip-title">{item?.title}</p>} */}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>

                    <div className="temp-section-content-right">
                        <div className="content-right-texts">
                            <p className="content-right-texts-desc">{productList?.desc}</p>
                        </div>
                        <div className="content-right-points">
                            {productList?.icons?.map((iconItem, iconIndex) => (
                                <div key={iconIndex} className="content-right-point">
                                    <div className="content-right-point-icon">
                                        <EFPicture src={iconItem.icon} />
                                    </div>
                                    <p className="content-right-point-title">{iconItem?.title}</p>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
